import { c as _c } from "react/compiler-runtime";
import { getReadableBookingStatus } from 'modules/calendar/constants/calendar-loco';
import Badge from 'shared/components/badge';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { BookingStatusEnum } from '../constants';
import { getPaymentStatusBooking, PaymentStatusBookingEnum } from '../enums/payment-status-booking-enum';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import React from 'react';
import { BookingsInterface } from '../types/booking-details-interface';
interface BookingStatusProps {
  status: BookingStatusEnum;
}
export const BookingStatus = t0 => {
  const $ = _c(5);
  const {
    status
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== status || $[1] !== t) {
    t1 = t(getReadableBookingStatus(status));
    $[0] = status;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Badge text={t1} classNames="bg-[rgb(var(--background-tertiary))]/70 text-[rgb(var(--text-primary))] w-fit capitalize" />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
interface BookingPaymentStatusLinkProps {
  booking: BookingsInterface;
}
export const BookingPaymentStatusLink = t0 => {
  const $ = _c(11);
  const {
    booking
  } = t0;
  const {
    t
  } = useLocoTranslation();
  switch (booking.paymentStatus) {
    case PaymentStatusBookingEnum.Refunded:
    case PaymentStatusBookingEnum.Completed:
      {
        const t1 = `/payment/transactions?filter=%7B%22orderItemId%22%3A${booking.orderItemId}%7D`;
        let t2;
        if ($[0] !== booking.paymentStatus || $[1] !== t) {
          t2 = t(getPaymentStatusBooking(booking.paymentStatus));
          $[0] = booking.paymentStatus;
          $[1] = t;
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        let t3;
        if ($[3] !== t1 || $[4] !== t2) {
          t3 = <LinkWithoutPrefetch href={t1} rel="noreferrer" target="_blank" className="primary-link cursor-pointer">{t2}</LinkWithoutPrefetch>;
          $[3] = t1;
          $[4] = t2;
          $[5] = t3;
        } else {
          t3 = $[5];
        }
        return t3;
      }
    default:
      {
        let t1;
        if ($[6] !== booking.paymentStatus || $[7] !== t) {
          t1 = t(getPaymentStatusBooking(booking.paymentStatus));
          $[6] = booking.paymentStatus;
          $[7] = t;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        let t2;
        if ($[9] !== t1) {
          t2 = <span>{t1}</span>;
          $[9] = t1;
          $[10] = t2;
        } else {
          t2 = $[10];
        }
        return t2;
      }
  }
};